export const comments_5519472 = {"data":{"data":[],"links":{}}}